import { Link, SupportingContent } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { useInviteModalActions } from "shared-ui";

import { COMMON_MESSAGES } from "../../../../components/common-messages";

export const ShopifySupportingContent = () => {
  const intl = useIntl();
  const { openInviteModal } = useInviteModalActions();
  const openInviteModalHandler = () => {
    openInviteModal();
  };

  return (
    <>
      <SupportingContent
        faqItems={[
          {
            question: intl.formatMessage({
              id: "funding-application: shopify multiple store question",
              defaultMessage: "Connecting multiple stores from multiple accounts?",
            }),
            answer: intl.formatMessage(
              {
                id: "funding-application: shopify multiple store faq answer",
                defaultMessage:
                  "See our <link>Help Center article</link> for guidance on how to connect multiple Shopify stores from multiple accounts.",
              },
              {
                link: (chunks: ReactNode) => (
                  <Link
                    url="https://help-center.wayflyer.com/en/articles/210531-how-do-i-connect-my-shopify-store"
                    external
                  >
                    {chunks}
                  </Link>
                ),
              }
            ),
          },
        ]}
        securityInfo={{
          label: intl.formatMessage({
            id: "funding-application: data security statement",
            defaultMessage: "Your data is securely stored in encrypted databases",
          }),
          link: {
            external: true,
            linkText: intl.formatMessage(COMMON_MESSAGES.viewOurPrivacyNotice),
            url: "https://www.wayflyer.com/privacy-notice",
          },
        }}
        supportingLinks={{
          heading: intl.formatMessage({
            id: "funding-application: need help",
            defaultMessage: "Need help?",
          }),
          links: [
            {
              linkText: intl.formatMessage({
                id: "funding-application: invite team member shopify",
                defaultMessage: "Invite a team member to help connect",
              }),
              onClick: openInviteModalHandler,
            },
          ],
        }}
      />
    </>
  );
};
